import { Shield } from "lucide-react";

export const TrustBar = () => (
  <div className="flex items-center justify-center gap-2 flex-wrap mt-4">
    <Shield size={12} className="text-brand-pink" strokeWidth={2} />
    <span className="text-[clamp(0.65rem,0.8vw,0.875rem)] text-[#9CA3AF]">Enterprise security</span>
    <span className="text-brand-pink">•</span>
    <span className="text-[clamp(0.65rem,0.8vw,0.875rem)] text-[#9CA3AF]">GDPR compliant</span>
  </div>
);
